import { cn } from "@newxsystems/shared";
import { DaylightCardLink } from "../DaylightCardLink/DaylightCardLink";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import { DaylightRichText } from "../DaylightRichText/DaylightRichText";
import type { IImageContentGridBottomProps } from "./ImageContentGridBottom.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridBottom = ({
  columnCount,
  headingAs = "h3",
  imageAspectRatio,
  items,
}: IImageContentGridBottomProps) => {
  const Heading = headingAs;
  return (
    <div
      className={cn("grid grid-cols-1 gap-6 sm:grid-cols-2", columns[columnCount || 3])}
      data-reveal="stagger"
    >
      {items.map((item, index) => (
        <DaylightCardLink
          className="group/card flex flex-col overflow-hidden rounded-[14px] border border-border bg-surface-100 transition-colors duration-200 hover:bg-surface-200"
          key={index}
          link={item.cardLink}
        >
          <div className="flex flex-1 flex-col gap-3 p-4 md:p-6">
            <div className="flex items-center justify-between gap-4">
              <span className="signal-numeric text-xs text-primary">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span
                aria-hidden="true"
                className="font-daylight-body text-base leading-none text-ash transition-[transform,color] duration-200 ease-out group-hover/card:translate-x-1 group-hover/card:text-primary"
              >
                →
              </span>
            </div>
            <Heading className="max-w-[20ch] font-daylight-display text-xl font-semibold leading-[1.15] tracking-[-0.02em] text-foreground md:text-2xl">
              {item.heading}
            </Heading>
            {item.description ? (
              <DaylightRichText
                className="max-w-[42ch] text-base text-ash"
                content={item.description}
              />
            ) : null}
            {item.cardLink?.label ? (
              <span className="signal-label mt-1 text-primary">{item.cardLink.label}</span>
            ) : null}
          </div>
          <DaylightMedia
            aspectRatio={imageAspectRatio || "16:9"}
            className="rounded-none"
            framed={false}
            imageClassName="transition-transform duration-[600ms] ease-out group-hover/card:scale-[1.04]"
            media={item.image.image}
            effect={item.image.effect}
            sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
          />
        </DaylightCardLink>
      ))}
    </div>
  );
};

ImageContentGridBottom.displayName = "Content::ImageContentGridBottom";
